module.exports = __webpack_public_path__ + "img/pop_up_blue.4bc7789c.png";